<template>
    <console-layout width="100%" max-width="1280">

        <console-title>
            <span>룰렛 당첨자</span>
        </console-title>

        <console-search @search="page=1; search(true)">
            <v-row class="mt-2">
                <v-col cols="12" sm="6">
                    <v-date-field v-model="filter.createdAt[0]" label="참여일자" persistent-placeholder hide-details />
                </v-col>
                <v-col cols="12" sm="6">
                    <v-date-field v-model="filter.createdAt[1]" label="참여일자" persistent-placeholder hide-details />
                </v-col>
            </v-row>
            <v-row class="mt-2">
                <v-col cols="12" sm="3">
                    <v-select v-model="filter.isPayment" :items="isPayments" item-text="text" item-value="value" label="지급여부" persistent-placeholder hide-details @input="filter.searchValue = null;" />
                </v-col>
                <v-col cols="12" sm="3">
                    <v-select v-model="filter.searchKey" :items="searchKeys" item-text="text" item-value="value" label="검색조건" persistent-placeholder hide-details @input="filter.searchValue = null;" />
                </v-col>
                <v-col cols="12" sm="3">
                    <v-text-field v-model="filter.searchValue" label="검색어" clearable persistent-placeholder hide-details :disabled="!filter.searchKey" @keydown.enter="page = 1; search(true)" />
                </v-col>
            </v-row>
        </console-search>

        <console-body>
            <v-layout class="align-end">
                <span class="subtitle-2">검색수 : {{ summary?.totalCount?.format() }}</span>
                <v-spacer />
                <span>
                    <v-btn color="white" elevation="1" class="green--text px-2 ml-1" @click="excel">
                        <v-icon class="mr-2">mdi-microsoft-excel</v-icon>엑셀다운로드
                    </v-btn>
                </span>
            </v-layout>
    
            <v-data-table :items="logs" :headers="logsHeaders" hide-default-footer disable-sort disable-pagination class="mt-2 elevation-1">
                <template #[`item.isPayment`]="{item}">
                    <v-switch v-model="item.isPayment" :disabled="!$hasScope(['root', 'admin'])" hide-details class="pa-0 ma-0 d-inline-block" color="red lighten-2" @change="update({ _id: item._id, isPayment: item.isPayment })"/>
                </template>
                <template #[`item.createdAt`]="{item}">
                    <span>{{ $dayjs(item?.createdAt).format("YYYY-MM-DD")  }}</span>
                </template>
                <template #[`item.user.phone`]="{item}">
                    <span>{{ item?.user?.phone?.phoneNumberFormat() }}</span>
                </template>
            </v-data-table>
    
            <v-pagination v-model="page" :length="pageCount" total-visible="11" class="my-4" @input="search(true)"/>
        </console-body>


        <v-btn v-if="$hasScope(['root', 'admin'])" fab fixed bottom right color="accent" @click="create"><v-icon>mdi-pencil</v-icon></v-btn>

    </console-layout>
</template>

<script>
import api from "@/api";
import XLSX from "xlsx";
import VDateField from "@/components/plugins/vuetify/v-date-field.vue";
import { mdiMicrosoftExcel, mdiWatermark } from "@mdi/js";
import dayjs from 'dayjs';

export default {
    components: {
        VDateField
    },
    data(){
        return {
            show: false,

            mdiWatermark,
            mdiMicrosoftExcel,

            showSearch: true,

            filter: {
                createdAt: [ this.$route.query.createdAt?.[0] || '', this.$route.query.createdAt?.[1] || '' ],
                isPayment: this.$route.query.isPayment || null,
                searchKey: this.$route.query.searchKey || null,
                searchValue: this.$route.query.searchValue || null
            },

            page: +this.$route.query.page || 1,
            pageCount: 0,
            limit: 10,

            summary: { totalCount: 0 },

            logs: [],
            logsHeaders: [
                { text: "참여자 이름", value: "user.name", align: "center", width: 100 },
                { text: "ID", value: "user.username", align: "center", width: 100 },
                { text: "참여일자", value: "createdAt", align: "center", width: 200 },
                { text: "상품명", value: "config.name", align: "center", width: 250 },
                { text: "전화번호", value: "user.phone", align: "center", width: 200 },
                { text: "지급여부", value: "isPayment", align: "center", width: 100 },
                { text: "잔여 경품 수", value: "config.stock", align: "center", width: 200 },
            ],

            searchKeys: [
                { text: ":: 전체 ::", value: null },
                { text: "참여자 이름", value: "user.name" },
                { text: "ID", value: "user.username" },
                { text: "상품명", value: "config.name" },
                { text: "전화번호", value: "user.phone" },
            ],

            isPayments: [
                { text: ":: 전체 ::", value: null },
                { text: "지급", value: true },
                { text: "미지급", value: false },
            ]
        }
    },
    mounted(){
        this.init();
    },
    methods: {
        init(){
            this.search(false);
        },
        async search(routable = false){
            if(routable){
                this.$router.push({
                    query: { ...this.filter, page: this.page }
                });
            }
            
            let { summary, logs } = await api.console.roulette.logs.gets({
                headers: {
                    skip: (this.page - 1) * this.limit,
                    limit: this.limit
                },
                params: this.filter
            });

            this.logs = logs;
            this.summary = summary;
            this.pageCount = Math.ceil(summary.totalCount / this.limit);
        },

        async update(log){
            await api.console.roulette.logs.put(log);
        },

        async excel(){
            let { logs } = await api.console.roulette.logs.gets({ headers: { limit: 0 }, params: this.filter });

            let rows = [];
            logs.forEach(log => {
                rows.push({
                    "참여자 이름": log?.user?.name,
                    "ID": log?.user?.username,
                    "참여일자": dayjs(log?.createdAt).format("YYYY-MM-DD HH:mm:ss"),
                    "상품명": log?.config?.name,
                    "전화번호": log?.user?.phone.phoneNumberFormat(),
                    "지급여부": log?.isPayment ? "지급" : "미지급",
                    "잔여 경품 수": log?.config?.stock
                });
            });

            let workbook = new XLSX.utils.book_new();
            let worksheet = XLSX.utils.json_to_sheet(rows);

            XLSX.utils.book_append_sheet(workbook, worksheet, "룰렛이벤트 당첨자");
            XLSX.writeFile(workbook, "룰렛이벤트 당첨자.xlsx");
        }
    }
}
</script>